import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

import { ConfirmOptionsModel } from './typings/confirm.options';

@Component({
  selector   : 'confirmation-custom',
  template: require('./confirmation.custom.component.html')
})
export class ConfirmationCustomComponent {
  @Input() options: ConfirmOptionsModel;

  constructor (
    public activeModal: NgbActiveModal
  ) {}

  close ( key : string ) : void {
    this.activeModal.close(key);
  }
}
